import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import {
  Box,
  Button,
  Card,
  CardActionArea,
  Container,
  Fade,
  Grid,
  Slide,
  Stack,
  Typography,
  createTheme,
  ThemeProvider
} from "@mui/material";
import TenUsers from "./../../../../assets/images/10_users.svg";
import ThirtyUsers from "./../../../../assets/images/30_users.svg";
import arrowLeft from "./../../../../assets/images/arrow_left.svg";

const ProfPlanUsers = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { session } = useSelector((state) => state.session);

  const ProfessionalStep = () => {
    dispatch({
      type: "PURCHASE",
      purchase: {
        content: "ChoosePlan",
        step: "ProfPlanTen",
      },
      PostData: {
        sub: session.sub,
        product_id: [13],
        email: session.email,
      },
    });
  };

  const ProfessionalStepThirty = () => {
    dispatch({
      type: "PURCHASE",
      purchase: {
        content: "ChoosePlan",
        step: "ProfPlanThirty",
      },
      PostData: {
        sub: session.sub,
        product_id: [16],
        email: session.email,
      },
    });
  };

  const Back = () => {
    dispatch({
      type: "PURCHASE",
      purchase: {
        content: "ChoosePlan",
        step: "SelectPlan",
      },
    });
  };

  const theme = createTheme({
    palette: {
      ochreBack: {
        main: "#FFF",
        light: "#FFF",
        contrastText: "#787676",
      },
    },
  });

  const cardStyles = {
    cursor: 'pointer',
    transition: 'all 0.3s ease-in-out',
    height: '100%',
    '&:hover': {
      transform: 'translateY(-4px)',
      boxShadow: 6,
    }
  };

  const imageStyles = {
    width: '100%',
    maxWidth: 200,
    height: 'auto'
  };

  const typographyStyles = {
    marginBottom: 0,
    textAlign: "center",
    fontWeight: "bold",
    textTransform: "uppercase",
    color: '#662D91',
  };

  return (
    <Slide direction="right" in={true} mountOnEnter unmountOnExit>
      <Container maxWidth="md">
        <Box sx={{ p: 2 }}>
          <Typography
            variant="h6"
            component="h6"
            sx={{
              textAlign: 'center',
              mb: 4,
            }}
          >
            {t("purchase.how_do_you_plan_to_use_our_platform")}
          </Typography>

          <Grid container spacing={3} sx={{ mb: 3 }}>
            <Grid item xs={12} md={6}>
              <Fade in={true} timeout={200} style={{ transitionDelay: '200ms' }}>
                <Card sx={cardStyles}>
                  <CardActionArea
                    data-testid="buy_professional_tenUsers_btn"
                    onClick={ProfessionalStep}>
                    <Box sx={{ p: 3, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
                      <Box
                        component="img"
                        src={TenUsers}
                        alt="professional woman working"
                        sx={imageStyles}
                      />
                      <Typography
                        variant="h6"
                        component="div"
                        sx={typographyStyles}
                      >
                        {t("purchase.up_to_ten_users")}
                      </Typography>
                    </Box>
                  </CardActionArea>
                </Card>
              </Fade>
            </Grid>

            <Grid item xs={12} md={6}>
              <Fade in={true} timeout={300} style={{ transitionDelay: '300ms' }}>
                <Card sx={cardStyles}>
                  <CardActionArea
                    data-testid="buy_professional_thirtyUsers_btn"
                    onClick={ProfessionalStepThirty}>
                    <Box sx={{ p: 3, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
                      <Box
                        component="img"
                        src={ThirtyUsers}
                        alt="professional woman working"
                        sx={imageStyles}
                      />
                      <Typography
                        variant="p"
                        component="div"
                        sx={typographyStyles}
                      >
                        {t("purchase.up_to_thirty_users")}
                      </Typography>
                    </Box>
                  </CardActionArea>
                </Card>
              </Fade>
            </Grid>
          </Grid>

          <ThemeProvider theme={theme}>
            <Button
              data-testid="buy_backPlan_btn"
              onClick={Back}
              variant="contained"
              color="ochreBack"
              startIcon={
                <Box
                  component="img"
                  src={arrowLeft}
                  alt="flecha para a esquerda"
                  sx={{ width: 16, height: 16 }}
                />
              }
              sx={{
                width: "100%",
                fontWeight: "bold",
                gap: "15px",
              }}
            >
              {t("purchase.return")}
            </Button>
          </ThemeProvider>
        </Box>
      </Container>
    </Slide>
  );
};

export default ProfPlanUsers;